import { ConfigurationPanelService } from '../services/configuration-panel.service';
import { ItineraryParticipantInfoConfigurationPanelService } from '../services/itinerary-participant-info-configuration-panel.service';

export class ConfigurationPanelServiceResolver {
  public static isItineraryReportType(reportType: string | undefined): boolean {
    return reportType === 'Itinerary' || reportType === 'itinerary';
  }

  public static getServiceForReportType(reportType: string | undefined) {
    return this.isItineraryReportType(reportType)
      ? ItineraryParticipantInfoConfigurationPanelService
      : ConfigurationPanelService;
  }

  public static getConfigurationPanelService(reportType: string | undefined) {
    return this.getServiceForReportType(reportType);
  }
}
